import { atomFamily } from 'recoil';

export const searchTextAtomFamily = atomFamily<string, string>({
  key: 'searchTextAtomFamily',
  default: '',
});
